/* ============================================================
   c-top-feature : トップ Feature セクションのカテゴリタブ
   タブ押下でページ遷移せず、セクション内で表示グループを切り替える。
   グループ＝タグごとの最新N件（サーバ側で <ul data-group role="tabpanel"> として描画済み）。

   ARIA タブパターン:
   - タブ    : [role="tab"][data-tag]（ALL は data-tag=""／data-tag は handleize 済み）
   - パネル  : ul.c-top-feature__list[role="tabpanel"][data-group]（ALL は data-group=""）
   - roving tabindex（選択中のみ 0、他は -1）＋ 左右矢印 / Home / End で移動
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.c-top-feature').forEach((section) => {
    const tablist = section.querySelector('[role="tablist"]');
    const tabs = Array.from(section.querySelectorAll('.c-top-feature__tab'));
    const panels = Array.from(section.querySelectorAll('.c-top-feature__list'));
    const scroller = section.querySelector('.c-top-feature__scroller');
    if (!tablist || !tabs.length || !panels.length) return;

    const showPanel = (tag) => {
      panels.forEach((ul) => {
        const isCurrent = (ul.dataset.group || '') === (tag || '');
        ul.toggleAttribute('hidden', !isCurrent);
        if (isCurrent) {
          ul.setAttribute('data-active', '');
        } else {
          ul.removeAttribute('data-active');
        }
      });
      /* グループ切替後は横スクロール位置を先頭へ戻す */
      if (scroller) scroller.scrollLeft = 0;
    };

    /* タブの選択状態を更新（roving tabindex）。moveFocus=true でそのタブへフォーカス移動 */
    const selectTab = (tab, moveFocus) => {
      tabs.forEach((t) => {
        const isCurrent = t === tab;
        t.classList.toggle('is-active', isCurrent);
        t.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        t.setAttribute('tabindex', isCurrent ? '0' : '-1');
      });
      showPanel(tab.dataset.tag || '');
      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => selectTab(tab, false));
    });

    /* キーボード操作：←→で移動（端で循環）、Home/End で先頭・末尾 */
    tablist.addEventListener('keydown', (e) => {
      const current = tabs.indexOf(document.activeElement);
      if (current === -1) return;
      let next = null;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = (current + 1) % tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = (current - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = tabs.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      selectTab(tabs[next], true);
    });
  });
});
